// pages/Campaigns/Campaigns.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tabs, Tab } from '@mui/material';
import backendURL from "../../config";

export default function Campaigns() {
    useEffect(() => {
        document.title = 'Campaigns | KlonIT Web Application';
    }, []);



    return (
        <div>
            <main className="content">
                <div className="container-fluid p-0">
                    <div className="mb-3">
                        <h1 className="h3 d-inline align-middle"><strong>Campaigns </strong> </h1>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="card">
                                <div className="card-header text-center">
                                    <i className="fa fa-whatsapp fa-5x" aria-hidden="true"></i>

                                </div>
                                <div className="card-body text-center">
                                    <h3 className="card-title mb-0">Whatsapp Bulk Messaging</h3>
                                    <br />
                                    <p className="card-text">Send messages to multiple contacts instantly, making marketing and customer outreach seamless.</p>
                                    <a href="whatsapp-bulk-message" className="btn btn-primary">Configure</a>
                                </div>
                            </div>
                        </div>

                        {/* --- GMAIL INTEGRATION CARD WITH UPDATED DESCRIPTION --- */}
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="card">
                                <div className="card-header text-center">
                                    <i className="fa fa-google fa-5x" aria-hidden="true"></i>
                                </div>
                                <div className="card-body text-center">
                                    <h3 className="card-title mb-0">Gmail Auto-Responder</h3>
                                    <br />
                                    <p className="card-text">Connect your Gmail to automatically read and process incoming emails. Leverage AI to generate contextual replies.</p>
                                    <a href="/Campaigns/Gmail" className="btn btn-primary">Configure</a>
                                </div>
                            </div>
                        </div>
                        
                    </div>


                </div>
            </main>
        </div>
    );
}